import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import {BeatLoader} from "react-spinners";

import TrashIcon from "components/icons/TrashIcon";

import IconButton from "../../../../../../../../../../../../button/IconButton";

import {ReactComponent as TickCircle} from "assets/img/tick-circle.svg";
import {blue500, green50, grey300, red50, red500} from "assets/jss/main";

import deleteNotification from "api/notification/delete";
import {markAsRead} from "api/notification/update";

import {NotificationContext} from "../../../../../NotificationContext";

NotificationAction.propTypes = {
    notification: PropTypes.object,
    isHovered: PropTypes.bool
};

function NotificationAction({notification = null, isHovered = false}) {
    const [loading, setLoading] = useState(false);

    const {selectedNavigationToggle, reloadNotifications} = useContext(NotificationContext);

    if (!notification) {
        return null;
    }

    const TrashNotification = () => (
        <IconButton
            background={isHovered && grey300}
            hoverColor={red50}
            onClick={(e) => {
                e.stopPropagation();
                setLoading(true);
                deleteNotification(notification)
                    .then(() => reloadNotifications())
                    .finally(() => setLoading(false))
            }}
        >
            <TrashIcon color={red500} size={16} />
        </IconButton>
    )

    const ReadNotification = () => (
        <IconButton
            background={isHovered && grey300}
            hoverColor={green50}
            onClick={(e) => {
                e.stopPropagation();
                setLoading(true);
                markAsRead(notification)
                    .then(() => reloadNotifications())
                    .finally(() => setLoading(false))
            }}
        >
            <TickCircle />
        </IconButton>
    )

    const Actions = () => {
        if (loading) {
            return (
                <div style={{whiteSpace: 'nowrap'}}>
                    <BeatLoader size={3} color={blue500} />
                </div>
            )
        }

        if (selectedNavigationToggle === 0) {
            if (!notification.viewed) {
                return (
                    <TrashNotification />
                )
            } else {
                return (
                    <React.Fragment>
                        <TrashNotification />
                        <ReadNotification />
                    </React.Fragment>
                )
            }
        } else if (selectedNavigationToggle === 1) {
            return <TrashNotification />
        } else if (selectedNavigationToggle === 2) {
            return <ReadNotification />
        } else {
            return null;
        }
    }

    return (
        <div style={{
            cursor: 'pointer',
            display: 'flex',
            gap: '10px'
        }}>
            <Actions />
        </div>
    )
}

export default NotificationAction;
